import React from "react";
import spinSvg from "@/assets/svg/spin.svg";
import Image from "next/image";

const LoadingSpinner = () => {
  return <Image src={spinSvg} alt="Spinner" />;
};

export default LoadingSpinner;
